import React from 'react';
import { Link } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';
import { Button, Label } from '@atlas/ui';

const { CASINO, SPORT_PREMATCH } = COMPONENT_TYPES;

const EventNotFound = () => {
  const sportRoute = SiteConfigManager.getComponentPath(SPORT_PREMATCH);
  const casinoRoute = SiteConfigManager.getComponentPath(CASINO);

  return (
    <div className="event-not-found">
      <h3 className="event-not-found__title">404</h3>
      <Label className="event-not-found__subtitle" message="page_not_found" />
      <Label
        className="event-not-found__description"
        message="the_page_you_are_looking_for_may_have_been_deleted"
      />

      <div className="event-not-found__buttons">
        <Link className="primary link-wrapper" to={sportRoute}>
          <Button className="button" label="go_to_sport" size="big" type="primary" />
        </Link>
        <Link className="primary link-wrapper" to={casinoRoute}>
          <Button className="button" label="go_to_casino" size="big" type="primary" />
        </Link>
      </div>
    </div>
  );
};

export default EventNotFound;
